import React, { Component } from 'react';
import Header from '../components/header/header';
import TimeInterval from '../components/timeInterval/timeInterval';
import { Table, Button, Input, message, Popconfirm, Select, Pagination, ConfigProvider } from 'antd';
import Loading from '../../components/loading/loading';
import DocumentTitle from 'react-document-title';
import queryString from 'query-string';
import moment from 'moment';
import './userFromCensus.less';
import API from '../../../api/api';
import zhCN from 'antd/es/locale/zh_CN';
class UserCensus extends Component {
    constructor(props) {
        super(props);
        this.chooseDateRange = this.chooseDateRange.bind(this);
        this.clearTime = this.clearTime.bind(this);
    }
    state = {
        data: null,
        apiData: {
            pageNum: 1,
            pageSize : 10,
            startTime: '',
            endTime: '',
        },
        systemColor:'#4574F4',
        error: '',
        totalCount:0,
        columns:[
            {
                title:'来源/活动ID',
                dataIndex:'playId',
                key:'playId',
                width:150,
            },
            {
                title: '活动类型',
                dataIndex: 'playType',
                key: 'playType',
                width:150,
            },
            {
                title: '活动名称',
                dataIndex: 'playName',
                key: 'playName',
                width:150,
            },
            {
                title: '注册人数',
                dataIndex: 'registerNum',
                key: 'registerNum',
                width:150,
            },
            {
                title: '报名/被邀请注册数',
                dataIndex: 'invitateNum',
                key: 'invitateNum',
                width:150,
            },
        ]
    };
    componentWillReceiveProps() {
        this.submitSearch();
    }
    componentDidMount(){
        this.submitSearch();
    }
    chooseDateRange(value) {
        console.log(value);
        const { apiData } = this.state;
        apiData.startTime = value.startTime;
        apiData.endTime = value.endTime;
        this.setState({ apiData });
    }
    clearTime() {
        const { apiData } = this.state;
        delete (apiData.startTime);
        delete (apiData.endTime);
        this.setState({ apiData });
    }
    // 分页选择
    pageChange(pageNumber, pageSize) {
        const { apiData } = this.state;
        if (pageNumber != apiData.pageNum) {
            apiData.pageNum = pageNumber
            this.setState({ apiData }, () => {
                this.submitSearch();
            });
        }
        window.scrollTo(0,0);
    }
    // 每页展示多少个
    onShowSizeChange(current, size) {
        const { apiData } = this.state;
        if (size != apiData.pageSize ) {
            apiData.pageSize  = size;
            apiData.pageNum = 1;
            this.setState({ apiData }, () => {
                this.submitSearch();
            });
        }
    }
    getDataList = async (param) => {
        let result = await API.getUserFromCensus(param);
        if (!result) return;
        if (result.status == 1) {
            let dataList;
            if(param.pageNum==1&&result.data.totalList){
                let totalList=result.data.totalList;
                totalList[0].playId="总计";
                totalList[1].playId="其他";
                dataList=[...totalList,...result.data.sourceList]
            }else{
                dataList=result.data.sourceList;
            }
            this.setState({ dataList,totalCount:result.data.count})
            return;
        }
        message.error(result.msg);
    }
    submitSearch(type) {
        const { apiData } = this.state;
        if(type==1){
            apiData.pageNum=1;
            this.setState({apiData});
        }
        for (let key in apiData) {
            if (apiData[key] === '')
                delete (apiData[key])
        }
        this.getDataList(apiData)
    }
    render() {
        const {
            columns,
            dataList,
            apiData,
            systemColor,
            totalCount
        } = this.state;
        return (
            <DocumentTitle title="铛铛用户来源统计">
                <ConfigProvider locale={zhCN}><div className="userFromCensusPane">
                    <Header roleName={'铛铛用户来源统计'} systemColor={systemColor}></Header>
                    <div className="search-condition">
                        {/* 时间选择器 */}
                        <div className="time-tmp" id="time-tmp">
                            <TimeInterval
                                className="timePicker"
                                confirmCallback={this.chooseDateRange}
                                clearTime={this.clearTime}
                            ></TimeInterval>
                        </div>
                        {/* 搜索按钮 */}
                        <div className="search-btn" onClick={this.submitSearch.bind(this,1)}>搜索</div>
                    </div>
                    {/* 数据列表 */}
                    <div className="data-list">
                        {/* 数据列表 */}
                        <div className="list-box">
                                <Table
                                    pagination={false}
                                    bordered
                                    rowClassName="tableTd"
                                    disabled
                                    width={150}
                                    rowKey={row => row.id}
                                    columns={columns}
                                    dataSource={dataList}
                                />
                        </div>
                        {/* 分页 */}
                        <div className="list-page" >
                                <Pagination
                                    defaultPageSize={apiData.pageSize }
                                    showQuickJumper
                                    showSizeChanger
                                    current={apiData.pageNum}
                                    defaultCurrent={apiData.pageNum}
                                    total={totalCount}
                                    pageSizeOptions={['10', '20', '30', '40', '50']}
                                    onShowSizeChange={this.onShowSizeChange.bind(this)}
                                    onChange={this.pageChange.bind(this)}
                                />
                        </div>
                    </div>
                </div>
                </ConfigProvider>
            </DocumentTitle>
        )
    }
}
export default UserCensus;